import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, makeStyles, Typography } from '@material-ui/core';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';

import { GetTopicById } from '../../../services/courses';
import { setAnalytics } from '../../../utils';
import Buttons from '../Buttons';
import Headers from '../Headers';
import NotesCard from '../NotesCard';

import SkeletonContainerVideo from './SkeletonContainerVideo';
import Video from './Video';

const useStyles = makeStyles((theme) => ({
  videoButtonsContainer: {
    minHeight: 540,
    maxHeight: 600,
  },
  containerDinamic: {
    margin: '2% 0 0 0',
  },
  containerDescription: {
    background: theme.palette.background.card,
    borderRadius: '10px',
    padding: theme.spacing(2, 3),
    maxHeight: 246,
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      backgroundColor: theme.palette.background.grey,
      borderRadius: '10px',
      width: 15,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#1A3758',
      borderRadius: '10px',
    },
  },
  containerDescriptionText: {
    color: theme.palette.text.default,
    fontFamily: 'Raleway',
    fontSize: '14px',
  },
}));
function ContainerVideo({ data }) {
  const classes = useStyles();
  const location = useLocation();
  const [openNotes, setOpenNotes] = useState(false);
  const [description, setDescription] = useState('');
  const handleActionNotes = () => {
    setOpenNotes(!openNotes);
    setAnalytics('Lesson', 'Btn_GuardarNotaVideo');
  };
  const getDescription = async () => {
    const topic = await GetTopicById(location.state.topic);
    setDescription(topic.data.description);
  };

  useEffect(() => {
    getDescription();
  }, []);
  return (
    <Box>
      {data !== undefined ? (
        <>
          <Box className={classes.videoButtonsContainer}>
            <Video video={data.value} />
            <Buttons className={classes.containerDinamic} />
          </Box>
          <Headers actions={handleActionNotes} nameContent={data.title} />
          <Box className={classes.containerDinamic}>
            {openNotes ? (
              <NotesCard close={handleActionNotes} />
            ) : (
              <Box className={classes.containerDescription}>
                <Typography className={classes.containerDescriptionText}>
                  {parse(description)}
                </Typography>
              </Box>
            )}
          </Box>
        </>
      ) : (
        <SkeletonContainerVideo />
      )}
    </Box>
  );
}

export default ContainerVideo;

ContainerVideo.propTypes = {
  data: PropTypes.objectOf(PropTypes.string).isRequired,
};
